'use client';

import classNames from 'classnames';
import {
  forwardRef,
  MutableRefObject,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from 'react';

interface ModalBodyProps {
  className?: string;
  containerClassName?: string;
  children: ReactNode;
}

const ModalBody = forwardRef<HTMLDivElement, ModalBodyProps>(
  ({ className, children, containerClassName }, ref) => {
    const localRef = useRef<HTMLDivElement>(null);
    const [isAtTop, setIsAtTop] = useState(false);

    // Scroll to bottom: hide the button
    useEffect(() => {
      const currentRef = localRef.current;
      const handleScroll = () => {
        const element =
          (ref as MutableRefObject<HTMLDivElement | null>)?.current || currentRef;
        // const element = currentRef;
        if (element) {
          // const atTop = element.scrollHeight - element.scrollTop <= element.clientHeight + 1;
          const atTop = element.scrollTop <= 4;
          setIsAtTop(atTop);
        }
      };

      // const element = currentRef;
      const element =
        (ref as MutableRefObject<HTMLDivElement | null>)?.current || currentRef;
      if (element) {
        element.addEventListener('scroll', handleScroll);
        handleScroll();
      }

      return () => {
        // const element = currentRef;
        const element =
          (ref as MutableRefObject<HTMLDivElement | null>)?.current || currentRef;
        if (element) {
          element.removeEventListener('scroll', handleScroll);
        }
      };
    }, [ref]);

    return (
      <div
        className={classNames(
          'flex-1 overflow-auto',
          {
            'shadow-[rgba(0,0,0,0.1)_0_-1px_4px_0px]': !isAtTop,
          },
          containerClassName
        )}
        ref={ref}>
        <div className={classNames('modal-body px-6 pt-4 pb-4', className)}>
          {children}
        </div>
      </div>
    );
  }
);

ModalBody.displayName = 'ModalBody';
export default ModalBody;
